export const NotificationSubscriptionEventOrderStatusType = {
	order_status_changed: "order_status_changed",
	incoming_order_completed: "incoming_order_completed",
	outgoing_order_completed: "outgoing_order_completed",
	outgoing_order_loading_completed: "outgoing_order_loading_completed",
	outgoing_order_picking_completed: "outgoing_order_picking_completed",
};


export const NotificationSubscriptionEventOrderActivityType = {
	chat_message_added: "chat_message_added",
	order_fields_changed: "order_fields_changed",
	storage_indicator_changed: "storage_indicator_changed",
};


export const NotificationSubscriptionEventType = {
	...NotificationSubscriptionEventOrderStatusType,
	...NotificationSubscriptionEventOrderActivityType,
};
